module.exports = __webpack_public_path__ + "static/melbourne-tomato-fest-8cddcb17000570b9799af1138da3b4b4.jpg";